import { JsonFragment } from "../abis.model";

export const ActivitiesABI: JsonFragment[] = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_community",
        type: "address",
      },
      {
        internalType: "address",
        name: "_discordBotAddress",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "_id",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "enum Activities.Type",
        name: "_type",
        type: "uint8",
      },
      {
        indexed: false,
        internalType: "string",
        name: "_uri",
        type: "string",
      },
    ],
    name: "ActivityCreated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "_id",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "enum Activities.Type",
        name: "_type",
        type: "uint8",
      },
      {
        indexed: false,
        internalType: "string",
        name: "_uri",
        type: "string",
      },
    ],
    name: "ActivityFinalized",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "approved",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Approval",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "ApprovalForAll",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "_activityId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "_taskId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "_taker",
        type: "address",
      },
    ],
    name: "TaskFinalized",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "_activityId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "_taskId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "_taker",
        type: "address",
      },
    ],
    name: "TaskTaken",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Transfer",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "activityToTask",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "approve",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "baseURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "community",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_type",
        type: "uint256",
      },
      {
        internalType: "string",
        name: "_uri",
        type: "string",
      },
    ],
    name: "createActivity",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "_uri",
        type: "string",
      },
    ],
    name: "createTask",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "discordBotAddress",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_id",
        type: "uint256",
      },
      {
        internalType: "string",
        name: "_uri",
        type: "string",
      },
      {
        internalType: "address[]",
        name: "members",
        type: "address[]",
      },
    ],
    name: "finalizeActivity",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_activityId",
        type: "uint256",
      },
    ],
    name: "finilizeTask",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_type",
        type: "uint256",
      },
    ],
    name: "getActivitiesByType",
    outputs: [
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "getApproved",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getInteractionsAddr",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_activityId",
        type: "uint256",
      },
    ],
    name: "getTaskByActivityId",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "activityId",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "createdOn",
            type: "uint256",
          },
          {
            internalType: "enum Activities.TaskStatus",
            name: "status",
            type: "uint8",
          },
          {
            internalType: "address",
            name: "creator",
            type: "address",
          },
          {
            internalType: "address",
            name: "taker",
            type: "address",
          },
        ],
        internalType: "struct Activities.Task",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "idTypes",
    outputs: [
      {
        internalType: "enum Activities.Type",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
    ],
    name: "isApprovedForAll",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "isFinalized",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "onERC721Received",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "ownerOf",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "_data",
        type: "bytes",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "setApprovalForAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_activityId",
        type: "uint256",
      },
    ],
    name: "takeTask",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "tasks",
    outputs: [
      {
        internalType: "uint256",
        name: "activityId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "createdOn",
        type: "uint256",
      },
      {
        internalType: "enum Activities.TaskStatus",
        name: "status",
        type: "uint8",
      },
      {
        internalType: "address",
        name: "creator",
        type: "address",
      },
      {
        internalType: "address",
        name: "taker",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "tokenByIndex",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "tokenOfOwnerByIndex",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "tokenURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "transferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const artifact = {
  bytecode:
    "0x60806040523480156200001157600080fd5b5060405162003805380380620038058339810160408190526200003491620002bf565b6040518060400160405280600381526020016254736b60e81b8152506040518060400160405280600381526020016254534b60e81b815250620000846301ffc9a760e01b620001ba60201b60201c565b8151620000999060069060208501906200020c565b508051620000af9060079060208401906200020c565b50620000cb6380ac58cd60e01b6001600160e01b03620001ba16565b620000e6635b5e139f60e01b6001600160e01b03620001ba16565b6200010163780e9d6360e01b6001600160e01b03620001ba16565b50506001600160a01b038216620001355760405162461bcd60e51b81526004016200012c9062000334565b60405180910390fd5b600a80546001600160a01b038085166001600160a01b0319928316179092556010805492841692909116919091179055604051620001739062000291565b604051809103906000f08015801562000190573d6000803e3d6000fd5b50601180546001600160a01b0319166001600160a01b039290921691909117905550620003849050565b6001600160e01b03198082161415620001e75760405162461bcd60e51b81526004016200012c90620002fd565b6001600160e01b0319166000908152602081905260409020805460ff19166001179055565b828054600181600116156101000203166002900490600052602060002090601f016020900481019282601f106200024f57805160ff19168380011785556200027f565b828001600101855582156200027f579182015b828111156200027f57825182559160200191906001019062000262565b506200028d9291506200029f565b5090565b6103f9806200340c83390190565b620002bc91905b808211156200028d5760008155600101620002a6565b90565b60008060408385031215620002d2578182fd5b8251620002df816200036b565b6020840151909250620002f2816200036b565b809150509250929050565b6020808252601c908201527f4552433136353a20696e76616c696420696e7465726661636520696400000000604082015260600190565b60208082526014908201527f6e6f20636f6d6d756e6974792061646472657373000000000000000000000000604082015260600190565b6001600160a01b03811681146200038157600080fd5b50565b61307880620003946000396000f3fe608060405234801561001057600080fd5b50600436106101f05760003560e01c806362fe024a1161010f578063a22cb465116100a2578063dc1fb5a511610071578063dc1fb5a51461043e578063e985e9c514610446578063f7b7f88d14610459578063feebd12c14610479576101f0565b8063a22cb465146103fd578063b88d4fde14610410578063c87b56dd14610423578063ca5e167d14610436576101f0565b806370a08231116100de57806370a082311461039e57806381ad1ef9146103b15780638d977672146103d157806395d89b41146103f5576101f0565b806362fe024a146103505780636352211e146103635780636afeba8d146103765780636c0360eb14610396576101f0565b806323b872dd11610187578063436b3c2811610156578063436b3c281461030f57806348394873146103225780634f6ccce71461032a57806356deb1101461033d576101f0565b806323b872dd146102c35780632f745c59146102d657806333727c4d146102e957806342842e0e146102fc576101f0565b8063111002aa116101c3578063111002aa14610268578063150b7a021461027b57806318160ddd1461029b5780631ff8cb40146102b0576101f0565b806301ffc9a7146101f557806306fdde031461021e578063081812fc14610233578063095ea7b314610253575b600080fd5b610208610203366004612496565b61048c565b6040516102159190612702565b60405180910390f35b6102266104af565b6040516102159190612736565b610246610241366004612501565b610546565b604051610215919061266d565b610266610261366004612450565b610592565b005b6102666102763660046124ce565b61062a565b61028e610289366004612316565b610823565b604051610215919061270d565b6102a3610834565b6040516102159190612ec7565b6102666102be36600461255e565b610845565b6102666102d13660046122d6565b610a18565b6102a36102e4366004612450565b610a50565b6102086102f7366004612501565b610a81565b61026661030a3660046122d6565b610a96565b6102a361031d366004612501565b610ab1565b610246610ac3565b6102a3610338366004612501565b610ad2565b61026661034b366004612501565b610aee565b61026661035e366004612519565b610c9f565b610246610371366004612501565b610ddf565b610389610384366004612501565b610e0d565b6040516102159190612e77565b610226610ef6565b6102a36103ac366004612287565b610f57565b6103c46103bf366004612501565b610fa0565b6040516102159190612722565b6103e46103df366004612501565b610fb5565b604051610215959493929190612f38565b610226611002565b61026661040b366004612419565b611063565b61026661041e3660046123b1565b611131565b610226610431366004612501565b611170565b6102466112b6565b6102466112c5565b6102086104543660046122a2565b6112d4565b61046c610467366004612501565b611302565b60405161021591906126be565b610266610487366004612501565b611478565b6001600160e01b0319811660009081526020819052604090205460ff165b919050565b60068054604080516020601f600260001961010060018816150201909516949094049384018190048102820181019092528281526060939092909183018282801561053b5780601f106105105761010080835404028352916020019161053b565b820191906000526020600020905b81548152906001019060200180831161051e57829003601f168201915b505050505090505b90565b6000610551826116af565b6105765760405162461bcd60e51b815260040161056d90612b99565b60405180910390fd5b506000908152600460205260409020546001600160a01b031690565b600061059d82610ddf565b9050806001600160a01b0316836001600160a01b031614156105d15760405162461bcd60e51b815260040161056d90612ce9565b806001600160a01b03166105e36116c2565b6001600160a01b031614806105ff57506105ff816104546116c2565b61061b5760405162461bcd60e51b815260040161056d90612a15565b61062583836116c6565b505050565b600a54604051631c10191360e21b81526001600160a01b0390911690637040644c9061065a90339060040161266d565b60206040518083038186803b15801561067257600080fd5b505afa158015610686573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906106aa919061247a565b6106c65760405162461bcd60e51b815260040161056d906127dd565b60008151116106e75760405162461bcd60e51b815260040161056d90612c31565b60006106f4600183611734565b600e80546040805160a081018252848152426020820190815260009282018381523360608401526080830184905260018086018755959093528151600485027fbb7b4a454dc3493923482f07822329ed19e8244eff582cc204f8554c3620c3fd810191825591517fbb7b4a454dc3493923482f07822329ed19e8244eff582cc204f8554c3620c3fe83015592517fbb7b4a454dc3493923482f07822329ed19e8244eff582cc204f8554c3620c3ff90910180549697509395919492939092909160ff1916908360028111156107c557fe5b02179055506060820151600282018054610100600160a81b0319166101006001600160a01b0393841602179055608090920151600390910180546001600160a01b031916919092161790556000918252600d60205260409091205550565b630a85bd0160e11b95945050505050565b600061084060026117cd565b905090565b6010546001600160a01b0316331461086f5760405162461bcd60e51b815260040161056d90612926565b6000848152600b602052604081205460ff16600381111561088c57fe5b141580156108b7575060016000858152600b602052604090205460ff1660038111156108b457fe5b14155b6108d35760405162461bcd60e51b815260040161056d90612a72565b6000848152600f602052604090205460ff16156109025760405162461bcd60e51b815260040161056d90612d2a565b8251156109135761091384846117d8565b6000848152600f60205260408120805460ff191660011790555b818110156109c3576011546001600160a01b031663b95adfce8685858581811061095357fe5b90506020020160208101906109689190612287565b6040518363ffffffff1660e01b8152600401610985929190612ed0565b600060405180830381600087803b15801561099f57600080fd5b505af11580156109b3573d6000803e3d6000fd5b50506001909201915061092d9050565b506000848152600b6020526040908190205490517f22173be47f5f4297bba833614b1a23707e05332f81b2cd0dadb25ee2baff429c91610a0a91879160ff16908790612ee7565b60405180910390a150505050565b610a29610a236116c2565b8261181c565b610a455760405162461bcd60e51b815260040161056d90612db8565b6106258383836118a1565b6001600160a01b0382166000908152600160205260408120610a78908363ffffffff6119c116565b90505b92915050565b600f6020526000908152604090205460ff1681565b61062583838360405180602001604052806000815250611131565b600d6020526000908152604090205481565b6011546001600160a01b031690565b600080610ae660028463ffffffff6119cd16565b509392505050565b60016000828152600b602052604090205460ff166003811115610b0d57fe5b14610b2a5760405162461bcd60e51b815260040161056d90612d8c565b6000818152600d602052604081205490600e8281548110610b4757fe5b60009182526020909120600260049092020181015460ff1690811115610b6957fe5b14610b865760405162461bcd60e51b815260040161056d9061295d565b336001600160a01b0316600e8281548110610b9d57fe5b600091825260209091206004909102016002015461010090046001600160a01b03161415610bdd5760405162461bcd60e51b815260040161056d90612e40565b33600e8281548110610beb57fe5b906000526020600020906004020160030160006101000a8154816001600160a01b0302191690836001600160a01b031602179055506001600e8281548110610c2f57fe5b906000526020600020906004020160020160006101000a81548160ff02191690836002811115610c5b57fe5b02179055507f196fa3d9e6d88d51f193965903f96de5e59f5e704fdb540a72dbc56a04e56746828233604051610c9393929190612f19565b60405180910390a15050565b600a54604051631c10191360e21b81526001600160a01b0390911690637040644c90610ccf90339060040161266d565b60206040518083038186803b158015610ce757600080fd5b505afa158015610cfb573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610d1f919061247a565b610d3b5760405162461bcd60e51b815260040161056d906127dd565b6000826003811115610d4957fe5b6003811115610d5457fe5b1415610d725760405162461bcd60e51b815260040161056d9061288a565b6001826003811115610d8057fe5b6003811115610d8b57fe5b1415610da95760405162461bcd60e51b815260040161056d90612d55565b6000815111610dca5760405162461bcd60e51b815260040161056d90612c31565b610625826003811115610dd957fe5b82611734565b6000610a7b8260405180606001604052806029815260200161301a602991396002919063ffffffff6119e916565b610e15612120565b60016000838152600b602052604090205460ff166003811115610e3457fe5b14610e515760405162461bcd60e51b815260040161056d90612d8c565b6000828152600d6020526040902054600e80549091908110610e6f57fe5b90600052602060002090600402016040518060a001604052908160008201548152602001600182015481526020016002820160009054906101000a900460ff166002811115610eba57fe5b6002811115610ec557fe5b8152600282015461010090046001600160a01b03908116602083015260039092015490911660409091015292915050565b60098054604080516020601f600260001961010060018816150201909516949094049384018190048102820181019092528281526060939092909183018282801561053b5780601f106105105761010080835404028352916020019161053b565b60006001600160a01b038216610f7f5760405162461bcd60e51b815260040161056d90612aa1565b6001600160a01b0382166000908152600160205260409020610a7b906117cd565b600b6020526000908152604090205460ff1681565b600e8181548110610fc257fe5b600091825260209091206004909102018054600182015460028301546003909301549193509160ff8116916001600160a01b036101009092048216911685565b60078054604080516020601f600260001961010060018816150201909516949094049384018190048102820181019092528281526060939092909183018282801561053b5780601f106105105761010080835404028352916020019161053b565b61106b6116c2565b6001600160a01b0316826001600160a01b0316141561109c5760405162461bcd60e51b815260040161056d906128ef565b80600560006110a96116c2565b6001600160a01b03908116825260208083019390935260409182016000908120918716808252919093529120805460ff1916921515929092179091556110ed6116c2565b6001600160a01b03167f17307eab39ab6107e8899845ad3d59bd9653f200f220920489ca2b5937696c31836040516111259190612702565b60405180910390a35050565b61114261113c6116c2565b8361181c565b61115e5760405162461bcd60e51b815260040161056d90612db8565b61116a84848484611a00565b50505050565b606061117b826116af565b6111975760405162461bcd60e51b815260040161056d90612c9a565b60008281526008602090815260409182902080548351601f600260001961010060018616150201909316929092049182018490048402810184019094528084526060939283018282801561122c5780601f106112015761010080835404028352916020019161122c565b820191906000526020600020905b81548152906001019060200180831161120f57829003601f168201915b50505050509050606061123d610ef6565b9050805160001415611251575090506104aa565b81511561128357808260405160200161126b92919061263f565b604051602081830303815290604052925050506104aa565b8061128d85611a33565b60405160200161129e92919061263f565b60405160208183030381529060405292505050919050565b6010546001600160a01b031681565b600a546001600160a01b031681565b6001600160a01b03918216600090815260056020908152604080832093909416825291909152205460ff1690565b606060038211156113255760405162461bcd60e51b815260040161056d90612866565b6060611331600c611b05565b67ffffffffffffffff8111801561134757600080fd5b50604051908082528060200260200182016040528015611371578160200160208202803683370190505b5090506000805b611382600c611b05565b8110156113ea5784600381111561139557fe5b60038111156113a057fe5b6000828152600b602052604090205460ff1660038111156113bd57fe5b14156113e257808383815181106113d057fe5b60209081029190910101526001909101905b600101611378565b5060608167ffffffffffffffff8111801561140457600080fd5b5060405190808252806020026020018201604052801561142e578160200160208202803683370190505b50905060005b8281101561146f5783818151811061144857fe5b602002602001015182828151811061145c57fe5b6020908102919091010152600101611434565b50949350505050565b60016000828152600b602052604090205460ff16600381111561149757fe5b146114b45760405162461bcd60e51b815260040161056d90612d8c565b6000818152600d6020526040902054600e8054339190839081106114d457fe5b600091825260209091206004909102016002015461010090046001600160a01b0316146115135760405162461bcd60e51b815260040161056d90612aeb565b6001600e828154811061152257fe5b60009182526020909120600260049092020181015460ff169081111561154457fe5b146115615760405162461bcd60e51b815260040161056d9061295d565b6002600e828154811061157057fe5b906000526020600020906004020160020160006101000a81548160ff0219169083600281111561159c57fe5b02179055506000828152600f60205260409020805460ff19166001179055601154600e80546001600160a01b039092169163b95adfce918591859081106115df57fe5b906000526020600020906004020160030160009054906101000a90046001600160a01b03166040518363ffffffff1660e01b8152600401611621929190612ed0565b600060405180830381600087803b15801561163b57600080fd5b505af115801561164f573d6000803e3d6000fd5b505050507f89b03c0d03474496b110b8e8bfce188551e3e93177aa8edc38469b8bc1fb5d608282600e848154811061168357fe5b6000918252602090912060036004909202010154604051610c939392916001600160a01b031690612f19565b6000610a7b60028363ffffffff611b0916565b3390565b600081815260046020526040902080546001600160a01b0319166001600160a01b03841690811790915581906116fb82610ddf565b6001600160a01b03167f8c5be1e5ebec7d5bd14f71427d1e84f3dd0314c0f7b2291e5b200ac8c7c3b92560405160405180910390a45050565b600080611741600c611b05565b905061174d3082611b15565b61175781846117d8565b6000818152600b60205260409020805485919060ff1916600183600381111561177c57fe5b021790555061178b600c611b33565b7f9f29f2d6f5f07cdbde247fa6d5869ccdc7b7147d8ff52686b6e3ca9bd725f9728185856040516117be93929190612ee7565b60405180910390a19392505050565b6000610a7b82611b05565b6117e1826116af565b6117fd5760405162461bcd60e51b815260040161056d90612be5565b600082815260086020908152604090912082516106259284019061215a565b6000611827826116af565b6118435760405162461bcd60e51b815260040161056d906129c9565b600061184e83610ddf565b9050806001600160a01b0316846001600160a01b031614806118895750836001600160a01b031661187e84610546565b6001600160a01b0316145b80611899575061189981856112d4565b949350505050565b826001600160a01b03166118b482610ddf565b6001600160a01b0316146118da5760405162461bcd60e51b815260040161056d90612c51565b6001600160a01b0382166119005760405162461bcd60e51b815260040161056d906128ab565b61190b838383610625565b6119166000826116c6565b6001600160a01b038316600090815260016020526040902061193e908263ffffffff611b3c16565b506001600160a01b0382166000908152600160205260409020611967908263ffffffff611b4816565b5061197a6002828463ffffffff611b5416565b5080826001600160a01b0316846001600160a01b03167fddf252ad1be2c89b69c2b068fc378daa952ba7f163c4a11628f55a4df523b3ef60405160405180910390a4505050565b6000610a788383611b6a565b60008080806119dc8686611baf565b9097909650945050505050565b60006119f6848484611c0b565b90505b9392505050565b611a0b8484846118a1565b611a1784848484611c6a565b61116a5760405162461bcd60e51b815260040161056d9061278b565b606081611a5857506040805180820190915260018152600360fc1b60208201526104aa565b8160005b8115611a7057600101600a82049150611a5c565b60608167ffffffffffffffff81118015611a8957600080fd5b506040519080825280601f01601f191660200182016040528015611ab4576020820181803683370190505b50859350905060001982015b831561146f57600a840660300160f81b82828060019003935081518110611ae357fe5b60200101906001600160f81b031916908160001a905350600a84049350611ac0565b5490565b6000610a788383611d4f565b611b2f828260405180602001604052806000815250611d67565b5050565b80546001019055565b6000610a788383611d9a565b6000610a788383611e60565b60006119f684846001600160a01b038516611eaa565b81546000908210611b8d5760405162461bcd60e51b815260040161056d90612749565b826000018281548110611b9c57fe5b9060005260206000200154905092915050565b815460009081908310611bd45760405162461bcd60e51b815260040161056d90612b22565b6000846000018481548110611be557fe5b906000526020600020906002020190508060000154816001015492509250509250929050565b60008281526001840160205260408120548281611c3b5760405162461bcd60e51b815260040161056d9190612736565b50846000016001820381548110611c4e57fe5b9060005260206000209060020201600101549150509392505050565b6000611c7e846001600160a01b0316611f41565b611c8a57506001611899565b6060611d18630a85bd0160e11b611c9f6116c2565b888787604051602401611cb59493929190612681565b604051602081830303815290604052906001600160e01b0319166020820180516001600160e01b038381831617835250505050604051806060016040528060328152602001612fe8603291396001600160a01b038816919063ffffffff611f4716565b9050600081806020019051810190611d3091906124b2565b6001600160e01b031916630a85bd0160e11b1492505050949350505050565b60009081526001919091016020526040902054151590565b611d718383611f56565b611d7e6000848484611c6a565b6106255760405162461bcd60e51b815260040161056d9061278b565b60008181526001830160205260408120548015611e565783546000198083019190810190600090879083908110611dcd57fe5b9060005260206000200154905080876000018481548110611dea57fe5b600091825260208083209091019290925582815260018981019092526040902090840190558654879080611e1a57fe5b60019003818190600052602060002001600090559055866001016000878152602001908152602001600020600090556001945050505050610a7b565b6000915050610a7b565b6000611e6c8383611d4f565b611ea257508154600181810184556000848152602080822090930184905584548482528286019093526040902091909155610a7b565b506000610a7b565b600082815260018401602052604081205480611f0f5750506040805180820182528381526020808201848152865460018181018955600089815284812095516002909302909501918255915190820155865486845281880190925292909120556119f9565b82856000016001830381548110611f2257fe5b90600052602060002090600202016001018190555060009150506119f9565b3b151590565b60606119f68484600085612026565b6001600160a01b038216611f7c5760405162461bcd60e51b815260040161056d90612b64565b611f85816116af565b15611fa25760405162461bcd60e51b815260040161056d9061282f565b611fae60008383610625565b6001600160a01b0382166000908152600160205260409020611fd6908263ffffffff611b4816565b50611fe96002828463ffffffff611b5416565b5060405181906001600160a01b038416906000907fddf252ad1be2c89b69c2b068fc378daa952ba7f163c4a11628f55a4df523b3ef908290a45050565b6060824710156120485760405162461bcd60e51b815260040161056d90612983565b61205185611f41565b61206d5760405162461bcd60e51b815260040161056d90612e09565b60006060866001600160a01b0316858760405161208a9190612623565b60006040518083038185875af1925050503d80600081146120c7576040519150601f19603f3d011682016040523d82523d6000602084013e6120cc565b606091505b50915091506120dc8282866120e7565b979650505050505050565b606083156120f65750816119f9565b8251156121065782518084602001fd5b8160405162461bcd60e51b815260040161056d9190612736565b6040518060a0016040528060008152602001600081526020016000600281111561214657fe5b815260006020820181905260409091015290565b828054600181600116156101000203166002900490600052602060002090601f016020900481019282601f1061219b57805160ff19168380011785556121c8565b828001600101855582156121c8579182015b828111156121c85782518255916020019190600101906121ad565b506121d49291506121d8565b5090565b61054391905b808211156121d457600081556001016121de565b80356001600160a01b0381168114610a7b57600080fd5b600082601f830112612219578081fd5b813567ffffffffffffffff80821115612230578283fd5b604051601f8301601f191681016020018281118282101715612250578485fd5b60405282815292508284830160200186101561226b57600080fd5b8260208601602083013760006020848301015250505092915050565b600060208284031215612298578081fd5b610a7883836121f2565b600080604083850312156122b4578081fd5b6122be84846121f2565b91506122cd84602085016121f2565b90509250929050565b6000806000606084860312156122ea578081fd5b83356122f581612fae565b9250602084013561230581612fae565b929592945050506040919091013590565b60008060008060006080868803121561232d578081fd5b61233787876121f2565b945061234687602088016121f2565b935060408601359250606086013567ffffffffffffffff80821115612369578283fd5b81880189601f82011261237a578384fd5b803592508183111561238a578384fd5b89602084830101111561239b578384fd5b6020810194505050809150509295509295909350565b600080600080608085870312156123c6578384fd5b6123d086866121f2565b93506123df86602087016121f2565b925060408501359150606085013567ffffffffffffffff811115612401578182fd5b61240d87828801612209565b91505092959194509250565b6000806040838503121561242b578182fd5b61243584846121f2565b9150602083013561244581612fc3565b809150509250929050565b60008060408385031215612462578182fd5b61246c84846121f2565b946020939093013593505050565b60006020828403121561248b578081fd5b81516119f981612fc3565b6000602082840312156124a7578081fd5b81356119f981612fd1565b6000602082840312156124c3578081fd5b81516119f981612fd1565b6000602082840312156124df578081fd5b813567ffffffffffffffff8111156124f5578182fd5b61189984828501612209565b600060208284031215612512578081fd5b5035919050565b6000806040838503121561252b578182fd5b82359150602083013567ffffffffffffffff811115612548578182fd5b61255485828601612209565b9150509250929050565b60008060008060608587031215612573578182fd5b84359350602085013567ffffffffffffffff80821115612591578384fd5b61259d88838901612209565b945060408701359150808211156125b2578384fd5b81870188601f8201126125c3578485fd5b80359250818311156125d3578485fd5b88602080850283010111156125e6578485fd5b959894975050602090940194505050565b6000815180845261260f816020860160208601612f75565b601f01601f19169290920160200192915050565b60008251612635818460208701612f75565b9190910192915050565b60008351612651818460208801612f75565b8351908301612664828260208801612f75565b01949350505050565b6001600160a01b0391909116815260200190565b6001600160a01b03858116825284166020820152604081018390526080606082018190526000906126b4908301846125f7565b9695505050505050565b6020808252825182820181905260009190848201906040850190845b818110156126f6578351835292840192918401916001016126da565b50909695505050505050565b901515815260200190565b6001600160e01b031991909116815260200190565b602081016004831061273057fe5b91905290565b600060208252610a7860208301846125f7565b60208082526022908201527f456e756d657261626c655365743a20696e646578206f7574206f6620626f756e604082015261647360f01b606082015260800190565b60208082526032908201527f4552433732313a207472616e7366657220746f206e6f6e20455243373231526560408201527131b2b4bb32b91034b6b83632b6b2b73a32b960711b606082015260800190565b60208082526032908201527f546865207369676e6572206973206e6f742077686974656c697374656420617360408201527120636f7265207465616d206d656d6265722160701b606082015260800190565b6020808252601c908201527f4552433732313a20746f6b656e20616c7265616479206d696e74656400000000604082015260600190565b6020808252600a908201526957726f6e67207479706560b01b604082015260600190565b6020808252600790820152664e6f207479706560c81b604082015260600190565b60208082526024908201527f4552433732313a207472616e7366657220746f20746865207a65726f206164646040820152637265737360e01b606082015260800190565b60208082526019908201527f4552433732313a20617070726f766520746f2063616c6c657200000000000000604082015260600190565b6020808252601f908201527f4f6e6c7920446973636f726420426f742043616e2063616c6c20746869732e00604082015260600190565b6020808252600c908201526b77726f6e672073746174757360a01b604082015260600190565b60208082526026908201527f416464726573733a20696e73756666696369656e742062616c616e636520666f6040820152651c8818d85b1b60d21b606082015260800190565b6020808252602c908201527f4552433732313a206f70657261746f7220717565727920666f72206e6f6e657860408201526b34b9ba32b73a103a37b5b2b760a11b606082015260800190565b60208082526038908201527f4552433732313a20617070726f76652063616c6c6572206973206e6f74206f7760408201527f6e6572206e6f7220617070726f76656420666f7220616c6c0000000000000000606082015260800190565b6020808252601590820152741858dd1a5d9a5d1e48191bd95cdb9d08195e1a5cdd605a1b604082015260600190565b6020808252602a908201527f4552433732313a2062616c616e636520717565727920666f7220746865207a65604082015269726f206164647265737360b01b606082015260800190565b6020808252601a908201527f4f6e6c792063726561746f722063616e2066696e616c697a6521000000000000604082015260600190565b60208082526022908201527f456e756d657261626c654d61703a20696e646578206f7574206f6620626f756e604082015261647360f01b606082015260800190565b6020808252818101527f4552433732313a206d696e7420746f20746865207a65726f2061646472657373604082015260600190565b6020808252602c908201527f4552433732313a20617070726f76656420717565727920666f72206e6f6e657860408201526b34b9ba32b73a103a37b5b2b760a11b606082015260800190565b6020808252602c908201527f4552433732314d657461646174613a2055524920736574206f66206e6f6e657860408201526b34b9ba32b73a103a37b5b2b760a11b606082015260800190565b6020808252600690820152654e6f2055524960d01b604082015260600190565b60208082526029908201527f4552433732313a207472616e73666572206f6620746f6b656e2074686174206960408201526839903737ba1037bbb760b91b606082015260800190565b6020808252602f908201527f4552433732314d657461646174613a2055524920717565727920666f72206e6f60408201526e3732bc34b9ba32b73a103a37b5b2b760891b606082015260800190565b60208082526021908201527f4552433732313a20617070726f76616c20746f2063757272656e74206f776e656040820152603960f91b606082015260800190565b602080825260119082015270185b1c9958591e48199a5b985b1a5e9959607a1b604082015260600190565b60208082526018908201527f557365206372656174655461736b20666f72207461736b730000000000000000604082015260600190565b6020808252601290820152714e6f7420636f7265207465616d207461736b60701b604082015260600190565b60208082526031908201527f4552433732313a207472616e736665722063616c6c6572206973206e6f74206f6040820152701ddb995c881b9bdc88185c1c1c9bdd9959607a1b606082015260800190565b6020808252601d908201527f416464726573733a2063616c6c20746f206e6f6e2d636f6e7472616374000000604082015260600190565b6020808252601c908201527f43726561746f722063616e27742074616b6520746865207461736b2e00000000604082015260600190565b8151815260208083015190820152604082015160a0820190612e9881612fa1565b60408301526060838101516001600160a01b039081169184019190915260809384015116929091019190915290565b90815260200190565b9182526001600160a01b0316602082015260400190565b600084825260048410612ef657fe5b83602083015260606040830152612f1060608301846125f7565b95945050505050565b92835260208301919091526001600160a01b0316604082015260600190565b8581526020810185905260a08101612f4f85612fa1565b60408201949094526001600160a01b039283166060820152911660809091015292915050565b60005b83811015612f90578181015183820152602001612f78565b8381111561116a5750506000910152565b60038110612fab57fe5b50565b6001600160a01b0381168114612fab57600080fd5b8015158114612fab57600080fd5b6001600160e01b031981168114612fab57600080fdfe4552433732313a207472616e7366657220746f206e6f6e20455243373231526563656976657220696d706c656d656e7465724552433732313a206f776e657220717565727920666f72206e6f6e6578697374656e7420746f6b656ea26469706673582212205dec8cc1fc85284a5c229344d49cb70f1e98d6648fa474bd9e75aac812ab48ea64736f6c634300060a0033608060405234801561001057600080fd5b50600380546001600160a01b031916331790556103c7806100326000396000f3fe608060405234801561001057600080fd5b50600436106100575760003560e01c80631e14e5fc1461005c5780636f4885b51461007a578063a2501fe81461009a578063b95adfce146100ba578063ca5e167d146100cf575b600080fd5b6100646100d7565b60405161007191906102f4565b60405180910390f35b61008d61008836600461028e565b6100e6565b6040516100719190610388565b6100ad6100a83660046102b0565b610101565b6040516100719190610368565b6100cd6100c83660046102c8565b61013c565b005b61006461023e565b6003546001600160a01b031681565b6001600160a01b031660009081526002602052604090205490565b61010961025a565b50600090815260016020818152604092839020835180850190945280546001600160a01b03168452909101549082015290565b6003546001600160a01b0316331461016f5760405162461bcd60e51b815260040161016690610321565b60405180910390fd5b61017761025a565b6040518060400160405280836001600160a01b031681526020018481525090506101a1600061024d565b80600160006101b06000610256565b815260208082019290925260409081016000908120845181546001600160a01b0319166001600160a01b03918216178255948401516001918201559386168152600290925290819020805490920191829055517fc887608704f6b658625e6cdc3f620cd8d0729c8c4c9abd0171098159637bdf779161023191859190610308565b60405180910390a1505050565b6004546001600160a01b031681565b80546001019055565b5490565b604080518082019091526000808252602082015290565b80356001600160a01b038116811461028857600080fd5b92915050565b60006020828403121561029f578081fd5b6102a98383610271565b9392505050565b6000602082840312156102c1578081fd5b5035919050565b600080604083850312156102da578081fd5b823591506102eb8460208501610271565b90509250929050565b6001600160a01b0391909116815260200190565b6001600160a01b03929092168252602082015260400190565b60208082526027908201527f4f6e6c7920416374697669746965732063616e2063616c6c20746869732066756040820152663731ba34b7b71760c91b606082015260800190565b81516001600160a01b031681526020918201519181019190915260400190565b9081526020019056fea26469706673582212200483183bfe9803b74c4d924f2a44ae6f80c51d5b32871097aed758568a25a6c964736f6c634300060a0033",
};

export const ActivitiesByteCode = artifact.bytecode;
